// (Copyright) Confluent, Inc.

import { css } from 'styled-components';

type Height = number | string;

export type HeightProps = {
  height?: Height;
  maxHeight?: Height;
  minHeight?: Height;
};

type ComponentHeightProps = HeightProps;

const pxValue = (value: undefined | number | string) =>
  typeof value === 'number' ? `${value}px` : value;

const getHeightCss = (props: ComponentHeightProps) => {
  return css`
    height: ${pxValue(props.height) ?? 'auto'};
    max-height: ${pxValue(props.maxHeight) ?? 'none'};
    min-height: ${pxValue(props.minHeight) ?? 0};
  `;
};

export const heightProps = (defaultHeight?: HeightProps | null) => (props: ComponentHeightProps) =>
  getHeightCss({ ...defaultHeight, ...props });
